export const RECALL_ALLOCATION_GAP = `
  mutation RecallAllocationGap($input: RecallAllocationGapInput!) {
    recallAllocationGap(input: $input) {
      gapId
      status
      recalledAt
      recalledBy
      auditTrail
    }
  }
`
